export enum CustomerTypes {
    INDIVIDUAL = "individual",
    CHAMA = "chama",
    ISA = "isa",
    DSE = "dse"
}